<template>
  <div style="width: 100%; height: 100%; display: flex">
    <div style="width: 40%; height: 100%; display: flex;flex-direction: column">
      <div class="title">{{'已分配TOTAL'}}
      </div>
    <div style="width: 100%; height: 380px" id="rose"/>
    </div>
    <el-table :data="tableData" border style="width: 65%" height="100%" :header-cell-style="tableHeaderColor" :cell-style="cellColor">
      <el-table-column prop="full_name" fixed="left" label="销售" width="100" align="center" />
      <el-table-column prop="total" fixed="left" label="总数" width="100" align="center" sortable>
        <template #default="scope">
          <span class="number" @click="openWindow(scope.row,'')">{{scope.row.total}}</span>
        </template>
      </el-table-column>
      <el-table-column v-for="item in companyLevelList" :key="item.index" align="center"
                       :prop="item.value" :label="item.name" min_width="160" sortable>
        <template #default="scope">
          <span class="number" @click="openWindow(scope.row,item.value)">{{scope.row[item.value]}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "CustomerDataCount",
  data(){
    return{
      tableData:[],
      option:{
        title: {
          text: '总数量',
          top: '41%',
          left: '49%',
          textAlign: 'center',
          textStyle: {
            color: 'black',
            fontSize: '18px',
            lineHeight: 30
          }
        },
        legend: {
          top: 'bottom'
        },
        toolbox: {
          show: false,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)"
        },
        series: [
            {
              name: 'Nightingale Chart',
              type: 'pie',
              radius: [55, 125],
              center: ['50%', '50%'],
              itemStyle: {
                borderRadius: 6
              },
              data: [
                { value: 40, name: 'rose 1' },
                { value: 38, name: 'rose 2' },
                { value: 32, name: 'rose 3' },
                { value: 30, name: 'rose 4' },
                { value: 28, name: 'rose 5' },
                { value: 26, name: 'rose 6' },
                { value: 22, name: 'rose 7' },
              ]
            }
        ]
      }
    }
  },

  computed: {
    companyLevelList() {
      return this.$store.getters['core/getDictList']('company_level');
    },
  },

  methods: {
    renderEcharts(id,option) {
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        let _this = this

        chart.on('click', function (params) {
          let data = {
            dict_value:params.data.dict_value
          }
          _this.openAfterSaleChance(data)
        })

        if (id === 'rose') {
          chart.on('legendselectchanged', function (params) {
            let array = []
            option.series[0].data.map((item)=>{
              if (params.selected[item.name]){
                array.push(item)
              }
            })
            option.legend.selected = params.selected
            option.title.text = "合计\n" + _this.$sysMethod.getPieSum(array)
            chart.clear()
            chart.setOption(option)
          })
        }
      }
    },

    openWindow(row,dictValue){
      let data = {
        sales_user_id:row.id,
        dict_value:dictValue
      }
      this.openAfterSaleChance(data)
    },

    openAfterSaleChance(data) {
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "frame/FrameQuery";
      windowObj.componentParam = "after_sales_chance_manage";
      windowObj.name = "售后机会管理";
      windowObj.parentData = data;
      windowObj.height = 700 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1200 || this.$store.getters['core/getGlobalWindowWidth']

      this.$store.dispatch('core/openWindow', windowObj)
    },

    async getRoseChart() {
      let data = await this.$http('afterSalesService.getCompanyLevelCount');
      this.option.series[0].data = data
      this.option.series[0].data.forEach((item,index)=>{
        item.itemStyle = {
          color:this.companyLevelList[index].color
        }
        item.name = item.name+'/'+item.value
      })
      this.option.title.text = "合计\n" + this.$sysMethod.getPieSum(this.option.series[0].data)
      this.renderEcharts("rose",this.option)
    },

    async getSalesCount() {
      let data = await this.$http('afterSalesService.getSalesCount');
      this.tableData = data
      this.tableData.sort((a,b)=>b.total - a.total)
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0 && columnIndex === 2) {
        return JSON.parse(JSON.stringify({'color': '#FF6347'}));
      } else if (rowIndex === 0 && columnIndex === 3) {
        return JSON.parse(JSON.stringify({'color': '#90EE90'}));
      } else if (rowIndex === 0 && columnIndex === 4) {
        return JSON.parse(JSON.stringify({'color': '#40E0D0'}));
      } else if (rowIndex === 0 && columnIndex === 5) {
        return JSON.parse(JSON.stringify({'color': '#EE82EE'}));
      }
      if (columnIndex === 1) {
        return JSON.parse(JSON.stringify({'background-color': 'whitesmoke'}));
      } else if (columnIndex === 6) {
        return JSON.parse(JSON.stringify({'background-color': 'whitesmoke'}));
      } else if (columnIndex === 7) {
        return JSON.parse(JSON.stringify({'background-color': 'whitesmoke'}));
      } else if (columnIndex === 8) {
        return JSON.parse(JSON.stringify({'background-color': 'whitesmoke'}));
      } else if (columnIndex === 9) {
        return JSON.parse(JSON.stringify({'background-color': 'whitesmoke'}));
      }
    },

    cellColor({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        return JSON.parse(JSON.stringify({'color': '#FF6347'}));
      } else if (columnIndex === 3) {
        return JSON.parse(JSON.stringify({'color': '#90EE90'}));
      } else if (columnIndex === 4) {
        return JSON.parse(JSON.stringify({'color': '#40E0D0'}));
      } else if (columnIndex === 5) {
        return JSON.parse(JSON.stringify({'color': '#EE82EE'}));
      }
      if (columnIndex === 1) {
        return JSON.parse(JSON.stringify({'background-color': 'whitesmoke'}));
      } else if (columnIndex === 6) {
        return JSON.parse(JSON.stringify({'background-color': 'whitesmoke'}));
      } else if (columnIndex === 7) {
        return JSON.parse(JSON.stringify({'background-color': 'whitesmoke'}));
      } else if (columnIndex === 8) {
        return JSON.parse(JSON.stringify({'background-color': 'whitesmoke'}));
      }else if (columnIndex === 9) {
        return JSON.parse(JSON.stringify({'background-color': 'whitesmoke'}));
      }
    }
  },

  mounted(){
    this.getRoseChart()
  },

  created() {
    console.log(this.companyLevelList)
    this.getSalesCount()
  }
}
</script>

<style scoped>
.title{
  border-left: 3px solid steelblue;
  width: 80%;
  font-size: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.number{
  cursor: pointer;
}

.number:hover{
  border-bottom: 2px solid;
}
</style>